import { BehaviorSubject } from "rxjs";
import axios, { AxiosRequestConfig } from "./axios.service";
import { headers } from "../_helpers/requestHeaders";
import config from "../_helpers/app.constants";
import { defaultNumRequests, defaultRequestInterval } from "../_helpers";

const requestConfig: AxiosRequestConfig = {
  headers: { ...headers.defaultHeaders(), ...headers.backendApiKeyHeader },
};

export const iposService = {
  GetThrottle: async (venueId: number): Promise<Throttle> => {
    let uriPath = `${config.iPosServiceUrl}/internal/venues/${venueId}/throttle`;

    console.log("called iposService.GetThrottle");
    let throttleVal: Throttle = new Throttle();
    throttleVal.numRequests = 5;

    try {
      const result = await axios.get(uriPath, requestConfig).catch((error) => {
        console.log(error + " " + error.response.data);
      });

      if (result && result.data)
        throttleVal = JSON.parse(JSON.stringify(result.data));
    } catch (e) {
      console.log(e);
    }

    return throttleVal;
  },

  SetThrottle: async (venueId: number, numRequest: number): Promise<any> => {
    let uriPath = `${config.iPosServiceUrl}/internal/venues/${venueId}/throttle`;

    console.log("called iposService.SetThrottle");
    let requestInterval = defaultRequestInterval;
    const body = {
      NumRequests: numRequest,
      RequestInterval: requestInterval,
    };

    const result = await axios
      .patch(uriPath, body, requestConfig)
      .catch((error) => {
        console.log(error);
      });
  },

  GetLogEntries: async (
    venueId: number,
    logFilter: LogFilter
  ): Promise<PagedResults<LogEntry>> => {
    let logEntriesResult: PagedResults<LogEntry> = null;

    let uriPath = `${config.iPosServiceUrl}/internal/venues/${venueId}/logs`;

    console.log("called iposService.GetLogEntries");
    if (logFilter.ContainsFilter()) {
      let filterArray = [];

      if (logFilter.From) filterArray.push("From=" + logFilter.From.getTime());
      if (logFilter.To) filterArray.push("To=" + logFilter.To.getTime());
      if (logFilter.Status) filterArray.push(`Status="${logFilter.Status}"`);
      if (logFilter.Level) filterArray.push(`Level="${logFilter.Level}"`);
      if (logFilter.Offset !== null)
        filterArray.push("Offset=" + logFilter.Offset);
      if (logFilter.PageLimit !== null)
        filterArray.push("PageLimit=" + logFilter.PageLimit);
      if (filterArray.length > 0) {
        uriPath += "?" + filterArray.join("&");
      }
    }

    const result = await axios.get(uriPath, requestConfig).catch((error) => {
      console.log(error);
    });

    if (result && result.data) {
      try {
        logEntriesResult = JSON.parse(JSON.stringify(result.data));
      } catch (e) {
        console.log(e);
      }
    }

    return logEntriesResult;
  },
};

export class Throttle {
  public numRequests: number | null;
  public requestInterval: number | null;
}

export class PagedResults<TResult> {
  public totalResultCount: number | null;
  public totalPageCount: number;
  public results: TResult[] | null;
}

export class LogEntry {
  public id: string;
  public venueId: number | null;
  public traceId: string | null;
  public timeStamp: Date | null;
  public method: string | null;
  public posName: string | null;
  public level: string | null;
  public status: string | null;
  public endpoint: string | null;
  public queryParams: string | null;
  public bodyParams: string | null;
  public remoteIpAddress: string | null;
  public elapsedTimeMs: string | null;
  public description: string | null;
}

export class BaseFilter {
  public PageLimit: number | null;
  public Offset: number | null;
}

export class LogFilter extends BaseFilter {
  public From: Date | null;
  public To: Date | null;
  public Level: string | null;
  public Status: number | null;
  public TraceId: string | null;
  public Detail: string | null;

  public ContainsFilter(): boolean {
    let flag = false;
    if (
      this.From ||
      this.To ||
      this.Level ||
      this.Status ||
      this.TraceId ||
      this.PageLimit ||
      this.Offset
    ) {
      flag = true;
    }
    return flag;
  }
}

export default iposService;
